import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Acesso} from 'src/app/core/acesso';
import {ControlContainer, NgForm} from '@angular/forms';
import {ToastService} from 'src/app/services/toast/toast.service';
import {FrequenciaAcao} from "../../../core/frequencias_acoes";
import {SituacaoFrequenciaAcao} from "../../../core/situacao-frequencia-acao";
import {AlunoService} from "../../../services/aluno/aluno.service";
import * as _ from "lodash";
import {Aluno} from "../../../core/aluno";

@Component({
    selector: 'formulario-acoes-executadas-frequencia',
    templateUrl: './formulario-acoes-executadas-frequencia.component.html',
    styleUrls: ['./formulario-acoes-executadas-frequencia.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormularioAcoesExecutadasFrequenciaComponent implements OnInit {

    @Input() frequenciasAcao: FrequenciaAcao[];
    @Input() frequenciaAcao: FrequenciaAcao;

    @Input() index: number;
    @Input() perfilAcesso: Acesso;

    idRandomico = Math.random();
    situacaoFrequencia: SituacaoFrequenciaAcao = new SituacaoFrequenciaAcao();

    constructor(private drc: ChangeDetectorRef,
                private toastService: ToastService,
                private alunoService: AlunoService,) {
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }

    deletar() {
        this.frequenciasAcao.splice(this.index, 1);
        this.toastService.showSucesso("Participante removido com sucesso.")
    }

    onValorChangeAluno(registro: any) {
        if (registro && registro.id) {
            const alunoJaCadastrado = _.find(this.frequenciasAcao, (participantesAcao: FrequenciaAcao) => participantesAcao.aluno?.id === registro.id);
            if (_.isEmpty(alunoJaCadastrado)) {
                this.alunoService.getById(registro.id).subscribe((aluno: Aluno) => {
                    this.frequenciaAcao.aluno = aluno;
                })
            } else {
                this.toastService.showAlerta("Participante já adicionado.")
                this.frequenciasAcao.splice(this.index, 1);
                this.frequenciaAcao = new FrequenciaAcao();
                this.frequenciasAcao.splice(this.index, 0, this.frequenciaAcao);
            }
        }
    }


}
